<template>
  <mini-card :value="totalPending" :subtitle="'Pending'">
    <div slot="header" class="icon-warning">
      <i class="fad fa-file-invoice-dollar text-success"></i>
    </div>
    <template slot="footer">
      <div class="row small ml-0">
        <span><i class="far fa-clock mr-2"/>Last created: &nbsp;<i>{{ lastCreated }}</i></span>
      </div>
    </template>
  </mini-card>
</template>

<script>
import MiniCard from './MiniCard.vue'
import utils from '../../utils'
export default {
  name: 'Invoices-Pending-MiniCard',
  components: {
    MiniCard
  },
  methods: {},
  computed: {
    lastCreated () {
      const invoices = this.$store.getters.invoices
      let date = new Date(0)
      if (invoices && invoices.length > 0) {
        invoices.forEach(i => {
          if (!i.archived && i.dateCreated && i.dateCreated.getTime() > date.getTime()) {
            date = i.dateCreated
          }
        })
        if (date.getTime() > 0) {
          return utils.dateToString(date)
        }
        else {
          return '-'
        }
      }
    },
    totalPending () {
      let total = 0
      this.$store.getters.invoices.forEach(i => i.status == 'pending' ? total += Math.round(100*utils.calcTotal(i)) : null)
      return utils.displayAmount(total/100)
    }
  }
}
</script>

<style>

</style>